import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const TemplateContainer = styled.div`
  max-width: 100vw !important;
  position: relative;
  overflow: hidden;

  & > div.gatsby-image-wrapper {
    position: relative;
    left: -5px;
    width: calc(100% + 10px);
  }
`

export const LegalContainer = styled.div`
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
  padding: 80px 24px;

  // used !important to fully override the max-width other than 1440px, wich is the default for all div's directly under <Layout>
  max-width: 760px !important;
  width: 100%;

  table {
    table-layout: fixed;
    width: 100%;
    border: 2px solid ${palette.text};
    border-collapse: collapse;
    margin-bottom: 1.5em;

    tbody, thead {
      tr {
        text-align: left;
        border-bottom: 2px solid ${palette.text};

        td, th {
          font-size: 1em;
          padding: 15px 3px;
          border: 1px solid ${palette.text};
          font-weight: 300;

          @media all and (max-width: ${layout.sm}) {
            font-size: 0.8em;
          }

          a {
            word-break: break-all;
            color: ${palette.snowFlower};
            text-decoration: none;
            font-weight: 400;
          }
        }
      }
    }
  }
`

export const TemplateTitleCard = styled.div`
  padding: 80px 48px;
  background-color: ${palette.white};
  box-shadow: 0 1px 20px rgb(0 0 0 / 15%), 0 0 1px rgb(0 0 0 / 5%);
  display: grid;
  row-gap: 2rem;
  position: relative;
  z-index: 2;
`

export const TemplateContent = styled.div`
  max-width: 712px;
  margin: 0px auto;

  p.center{
    text-align: center;
    margin-bottom: 2rem;
  }
  p {
    font-size: 1em;
    font-weight: 300;
    line-height: 1.7;
    -webkit-font-smoothing: antialiased;
    font-family: 'Lato';
    margin-bottom: .875em;

    @media all and (max-width: ${layout.xs}) {
      font-size: 1rem;
    }
  }
  a {
    text-decoration: none;
    color: ${palette.snowFlower};
    font-weight: 400;

    &.button{
      background: ${palette.snowFlower};
      color: ${palette.white};
      min-width: 256px;
      padding: 11px 20px 13px;
      border-radius: 4px;
      font-weight: 500;
      justify-self: center;
      position: relative;
      top: 0.5rem;
    }
  }
  h1 {
    font-size: 2em;
    line-height: 1.25em;
    font-family: 'Walsheim';

    @media all and (max-width: ${layout.sm}) {
      font-size: 1.375em;
    }
  }
  h3 {
    font-size: 2em;
    line-height: 1.4;
    margin: 0;
    padding-top: 24px;
    font-family: 'Walsheim';
  }
  h4 {
    font-size: 1.25em;
    line-height: 1.25em;
    font-family: 'Walsheim';
    margin-top: 0;
    margin-bottom: 1em;
  }
  ul {
    margin-bottom: 0;
    margin-left: 0;
    padding-left: 20px;
    list-style-type: disc;

    li {
      margin-bottom: 20px;
      font-size: 1em;
      font-weight: 300;
      -webkit-font-smoothing: antialiased;
    }
  }

  ol {
    margin-bottom: 0;
    margin-left: 0;
    padding-left: 20px;

    li {
      margin-bottom: 20px;
      font-size: 1em;
      font-weight: 300;
      -webkit-font-smoothing: antialiased;
    }
  }

  img {
    position: relative;
    width: calc(100% + 100px);
    left: -50px;

    @media all and (max-width: ${layout.subLg}) {
      width: calc(100%);
      left: 0px;
    }
  }
`
